const BookAuthor = ({ author }) => {
  return <div>{author}</div>;
};

export default BookAuthor;
